import {SFV} from "../core/single-file-view";
import {Features} from "../core/api";

export const Helpers = {

	/**
	 * Returns a library loaded into ActiveJS
	 * @param {String} key
	 * @returns {Object}
	 */
	getLib(key="") {
		let libFound = false;
		for (const dependency in $ActiveJS['Libraries']) if (dependency === key) libFound = $ActiveJS['Libraries'][dependency];
		if (libFound !== false) return libFound;
	}
};

export  const SFV_Support = {
	/**
	 * Support for the old framework
	 * @param name
	 * @param controller
	 */
	newController: async (name, controller) => {

		const obj = {
			fileName: name,
			Data: Reactive(controller.Data()),
			$props: ($ActiveJS.PassedProps)?$ActiveJS.PassedProps:{},
			// _Init: controller._Init,
			_Mounted: (controller._Mounted)?controller._Mounted:false,
			_Rendered: (controller._Rendered)?controller._Rendered:false,
			_beforeUpdate: (controller._beforeUpdate)?controller._beforeUpdate:false,
			_Updated: (controller._Updated)?controller._Updated:false,
			helpers: {...Helpers},
		};

		// setup the VM data
		Features.VM = {
			viewWrapperId: name,
			...obj
		};

		Features.VM["Mounted"] = (controller._Mounted)?controller._Mounted.bind(Features.VM):false;
		Features.VM["Rendered"] = (controller._Rendered)?controller._Rendered.bind(Features.VM):false;

		// bind methods to object
		for (const method in controller.methods) Features.VM[method] = controller.methods[method].bind(Features.VM);

		// add observers if they exist
		if (controller.observers) for (const observer in controller.observers) Features.Observers[observer] = controller.observers[observer].bind(Features.VM);

		// setup global view variable
		window.$this = Features.VM;

		// mounted callback for views
		if (Features.VM["Mounted"]) Features.VM["Mounted"]();

		// start the render process
		await SFV.startRenderProcess();

		console.log(Features.VM);
		// tell system that expose is done running
		Features.exposeInitialRun = false;
	},
};